import * as React from 'react';
import { TextArea } from "@progress/kendo-react-inputs";
import { GetTransactionData } from "./Transaction";
import configData from "../config.json";
import { GetToken, GetUserId } from '../components/Session';

export const DocketPreview = (props) => {
    const trans = props.transaction;
    const site = props.site;
    const settings = props.settings;
    const [docket, setDocket] = React.useState("");

    if (trans !== undefined && site !== undefined) { 
        let o = { sites: null, customers: null, marks: null, sources: null, products: null, productCategories: null, users: null, vehicles: null, destinations: null, vehicleConfigurations: null };
        var td = GetTransactionData(trans, site.current, settings, true, o);
        const timeOffset = new Date().getTimezoneOffset() / 60;
        let init = {
            method: "POST",
            accept: "application/json",
            headers: { "Authorization": "Bearer " + GetToken(), "Content-type": "application/json" },
            body: JSON.stringify(td)
        };
        let url = `${configData.SERVER_URL}apiv7/private/getdocketpreview?offset=${timeOffset}`;
        fetch(url, init).then(response => response.text()).then(d => {
            let dx = String(d).replaceAll(/\[\/?b\]/gi, "");
            setDocket(dx);
        });
    }

    return (
        <div><TextArea rows={23} columns={100} value={docket} className="docketPreview" /></div>
    );
}